module.exports = __webpack_public_path__ + "static/img/pro10_tab4.d7874db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/pro10_tab4.jpg
// module id = GXfq
// module chunks = 171